import { CheckCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface NotificationActionsMobileProps {
  transformedNotifications: any[];
  loading: boolean;
  error: any;
  onMarkAsRead: (ids: string[], markAll?: boolean) => void;
  onRefetch: () => void;
  className?: string;
}

export function NotificationActionsMobile({
  transformedNotifications,
  loading,
  error: _error,
  onMarkAsRead: _onMarkAsRead,
  onRefetch,
  className,
}: NotificationActionsMobileProps) {
  // Check if there are any unread notifications
  const _hasUnreadNotifications = transformedNotifications.some(
    (notification) => !notification.isRead
  );

  return (
    <TooltipProvider>
      <div className={cn("flex items-center gap-1", className)}>
        {/* Refresh button */}
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              onClick={onRefetch}
              disabled={loading}
              className="h-7 w-7 p-0"
            >
              <RefreshCw className={cn("h-4 w-4", loading && "animate-spin")} />
              <span className="sr-only">Refresh notifications</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Refresh notifications</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}

// New component for read all button to be used in leading elements
export function ReadAllButton({
  transformedNotifications,
  onMarkAsRead,
  className,
}: {
  transformedNotifications: any[];
  onMarkAsRead: (ids: string[], markAll?: boolean) => void;
  className?: string;
}) {
  // Check if there are any unread notifications
  const hasUnreadNotifications = transformedNotifications.some(
    (notification) => !notification.isRead
  );

  if (!hasUnreadNotifications) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onMarkAsRead([], true)}
            className={cn("h-7 w-7 p-0", className)}
          >
            <CheckCircle className="h-3.5 w-3.5" />
            <span className="sr-only">Mark all as read</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Mark all as read</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
